import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NewsleterComponent } from '../newsleter/newsleter.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  @Input() showTopFooter = true;

  constructor(
    private readonly ngxSmartModalService: NgxSmartModalService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
  }

  isBusiness() {
    return this.router.url.indexOf('/biznes') === 0;
  }

  openNewsletterDialog() {
    this.ngxSmartModalService.create(
      'newsletter',
      NewsleterComponent,
      {
        escapable: false,
        dismissable: false
      }
      ).setData({business: this.isBusiness()}).open();
  }
}
